import React, { Suspense } from 'react';
import { Element } from 'react-scroll';
import { CSSReset, Spinner, Center } from '@chakra-ui/react';

const Hero = React.lazy(() => import('../Components/Home/Hero'));
const Overview = React.lazy(() => import('../Components/Home/Overview'));
const VisionMission = React.lazy(() => import('../Components/Home/VisionMission'));
const WhyEasyVend = React.lazy(() => import('../Components/Home/WhyEasyVend'));
const Services = React.lazy(() => import('../Components/Home/Services'));
const Contact = React.lazy(() => import('../Components/Home/Contact'));

const ScrollToTopButton = React.lazy(() => import('../Components/ScrollToTopButton'))
const mainColor = "#045846";
  const secColor = "#ed2224";

const Home = () => {
  return (
    <>
      <CSSReset />
      <Suspense fallback={
        <Center height="100vh">
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color={mainColor}
            size="xl"
          />
        </Center>
      }>
          <Hero />
          <Overview />
          <VisionMission />
          <WhyEasyVend />
          <Services />
          <Contact />
         <ScrollToTopButton />
      </Suspense>
    </>
  );
};

export default Home;

